export class BeginnerModeConstants {
    static readonly WAIT_MS_TO_FIT_DICE_NUMBER_ANIMATION = 5500
    static readonly WAIT_MS_BEFORE_AUTO_DICE_ROLL = 2300
    static readonly BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION = 500
}
